/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect} from 'react'
import GoogleZoom from '../components/GoogleZoom'

const OldDocuments = (props) => {
    // auth
    var CryptoJS = require("crypto-js");

    // boolean for toggling the screen
    const [ historyGate, steHistoryGate ] = useState(false)

    // content for this component
    const [ content, setContent ] = useState(null)

    // state for displaying
    const [ rentalVanArray, setRentalVanArray ] = useState([])

    // state for selected document
    const [ selectedDocument, setSelectedDocument ] = useState('')

    // document selected details
    const [ selectedDocumentDetails, setSelectedDocumentDetails ] = useState(null)

    // funstion for seeing picture bigger
    const handleSelectDoc = (e, data, details) => {
        setSelectedDocument(data)
        setSelectedDocumentDetails(details)
    }

    // grab the props and map the data
    useEffect( () => {
        setRentalVanArray([])
        if (props.selectedDriver) {
            // get list of vans and registration
            async function postData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                    });

                return response ? response.json() : console.log('no reponse')
            };

            postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                "driver_id": props.selectedDriver.driver_id
            }).then( response => {
                // local mapped data
                let localComplainceArray = []
                let localRentalVanArray = []
                response.data.forEach( (image) => {
                    if (image.storageBool) {
                        if ( image.imagesLink.includes('.pdf')) {
                            let pageString = 'pg_1/'
                            let begginingOfUrl = image.imagesLink.slice(0, 53)
                            let endOfUrlUrl = image.imagesLink.slice(53)
                            let endUrlString = begginingOfUrl.concat(pageString).concat(endOfUrlUrl)
                            let pngUrlPdf = endUrlString.replace(/.pdf/, '.png')
                            localRentalVanArray.push(
                                <div className='imageForDisplay' onClick={(e) => handleSelectDoc(e, pngUrlPdf, image)}>
                                    <h3>{image.name}</h3>
                                    <img src={pngUrlPdf} alt={image.name} className='imageClass'/>
                                </div>
                            )
                        } else {
                            localRentalVanArray.push(
                                <div className='imageForDisplay' onClick={(e) => handleSelectDoc(e, image.imagesLink, image)}>
                                    <h3>{image.name}</h3>
                                    <img src={image.imagesLink} alt={image.name} className='imageClass'/>
                                </div>
                            )
                        }              
                    }
                })
    
                // set data to state for render
                setRentalVanArray(localRentalVanArray)
            })
        }
    }, [props.selectedDriver])

    // function for toggling the history screen
    const handleClick = () => {
        historyGate ? steHistoryGate(false) : steHistoryGate(true)
    }

    // remove the selected doc
    const handleRemoveDoc = () => {
        setSelectedDocument('')
    }

    const removeFromList = (e, highlightedInformation) => {
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };

        putData(`https://backendpajamas.herokuapp.com/images/${selectedDocumentDetails.image_id}/`, {
            storageBool: false,
        }).then( response => {
            props.reRender()
            handleClick()
        })
    }

    // toggle the screen
    useEffect( () => {
        if (historyGate) {
            if (selectedDocument) {
                setContent(
                    <div className='oldDocuments'>
                        <GoogleZoom img={selectedDocument}/>
                            <div 
                                className='viewDriverHistoryTwo'
                                onClick={handleRemoveDoc}
                            >
                                Return
                            </div>
                            {(props.superUser || props.user_email === "compliance@h2ologistics.co.uk" || props.email === "compliance@h2ologistics.co.uk" || props.user_email === "Compliance@h2ologistics.co.uk" || props.email === "Compliance@h2ologistics.co.uk") ? <div 
                                className='viewDriverHistoryThree'
                                onClick={(e) => removeFromList(e, selectedDocument)}
                            >
                                Remove
                            </div> : null}
                            
                    </div>
                )
            } else {
                setContent(
                    <div className='oldDocuments'>
                        <div className='listsContainer'>
                            <div className='rentalVanOldContainer'>
                                {rentalVanArray}
                            </div>
                            <div 
                                className='viewDriverHistoryTwo'
                                onClick={handleClick}
                            >
                                Return
                            </div>
                        </div>
                    </div>
                )
            }
        }
        else {
            setContent(
                <div 
                    className='viewDriverHistory'
                    onClick={handleClick}
                >
                    Previous Docs
                </div>
            )
        }

    }, [historyGate, selectedDocument, rentalVanArray, props])
    
    
    return (
        <>
            {content}
        </>
    )
}

export default OldDocuments